import * as req from 'api/actions';
import * as c from './constant';

export const getTransactionCount = (
  payload = { module_type: 'T_BPLS' },
  callback
) =>
  req.list(
    c.GET_TRANSACTION_COUNTS,
    'api/temp/administrators/transaction_histories/business_permit',
    payload,
    callback
  );

export const getOrdinanceRevisionEffectivity = (payload, callback) =>
  req.list(
    c.GET_ORDINANCE_REVISION_EFFECTIVITY,
    `/api/v1/bpls/administrator/common/ordinance_revisions`,
    payload,
    callback
  );